export const isBilletteriePartner = (state, partnerId) =>
    !!partnerId && !!state.billetterie.partnerIds[partnerId];

// Vrai tant que le référentiel n'a ni répondu ni échoué (état initial compris)
export const isBilletteriePending = state =>
    !state.billetterie.fetched && !state.billetterie.failed;



// WEBPACK FOOTER //
// ./src/services/billetterie/selector.js